import { createStore } from 'vuex';
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';

const api_host = 'https://voowe.ru/api';

const store = createStore({
  plugins: [createPersistedState()],
  namespaced: true,

  state() {
    return {
      role: 0,
      token: '',
      user: {},
    };
  },

  actions: {
    authorization({ commit, state }, pack) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            api_host + '/authorization',
            { pack },
            { headers: { Authorization: 'Bearer ' + state.token } }
          )
          .then((res) => {
            if ('user' in res.data) {
              commit('setUser', res.data.user);
              commit('setRole', res.data.user.role);
            }
            if ('token' in res.data) {
              commit('setToken', res.data.token);
              commit('setAuthorized', true);
            }
            if ('addresses' in res.data) {
              commit('setAddresses', res.data.addresses);
            }

            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    registration({ commit, state }, pack) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            api_host + '/registration',
            { pack },
            { headers: { Authorization: 'Bearer ' + state.token } }
          )
          .then((res) => {
            if ('user' in res.data) {
              commit('setUser', res.data.user);
              commit('setRole', res.data.user.role);
            }
            if ('token' in res.data) {
              commit('setToken', res.data.token);
              commit('setAuthorized', true);
            }
            if ('addresses' in res.data) {
              commit('setAddresses', res.data.addresses);
            }

            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    recovery({ state }, pack) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            api_host + '/recovery',
            { pack },
            { headers: { Authorization: 'Bearer ' + state.token } }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },


    getTrand({ state }, pack) {
      return new Promise((resolve) => {
        axios
          .post(
            api_host + '/get_trand',
            { pack },
            { headers: { Authorization: 'Bearer ' + state.token } }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err);
          });
      });
    },

    getBotInfo({ state }, pack) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            api_host + '/get_bot_info',
            { pack },
            { headers: { Authorization: 'Bearer ' + state.token } }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    send_order({ state }, pack) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            api_host + '/send_order',
            { pack },
            { headers: { Authorization: 'Bearer ' + state.token } }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

  },

  mutations: {
    setUser(state, user) {
      state.user = user;
    },

    setAddresses(state, addresses) {
      state.addresses = addresses.filter((item) => item.status == 1);
    },

    setToken(state, token) {
      state.token = token;
    },

    setRole(state, role) {
      state.role = role;
    },

    setAuthorized(state, authorized) {
      state.authorized = authorized;
    },

    exit(state) {
      state.role = 0;
      state.token = '';
      state.profile = {};
      state.authorized = false;
    },
  },

  getters: {
    getId(state) {
      if ('user' in state) {
        if ('id' in state.user) return state.user.id;
      }
      return false;
    },

    getName(state) {
      if ('name' in state.user) {
        if (state.user.name != null) return state.user.name;
      }
      return '(не найдено)';
    },

    getRole(state) {
      if ('role' in state) {
        if (state.role != null) return state.role;
      }
      return 0;
    },

    getLogin(state) {
      if ('login' in state.user) {
        if (state.user.login != null) return state.user.login;
      }
      return '(не найдено)';
    },

    getPhone(state) {
      if ('phone' in state.user) {
        if (state.user.phone != null) return state.user.phone;
      }
      return '(не найдено)';
    },

    getEmail(state) {
      if ('email' in state.user) {
        if (state.user.email != null) return state.user.email;
      }
      return '(не найдено)';
    },

  },
});

export default store;
